import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CheckBoxOptions, ControlLayout, DropdownOptions, FilterItem, FilterType, InputType, PagingOptions, TextBoxOptions, ToggleSlideOptions } from 'bnsights-control-library';
import { ActiveDirectoryService } from '../../shared/Services/ActiveDirectoryService.service';
import { ActiveDirectoryAddEditModel } from '../../shared/models/ADModels/ActiveDirectoryAddEditModel';
import { ADMappingModel } from '../../shared/models/ADModels/ADMappingModel';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bnsights-utilities-library';


@Component({
  selector: 'lib-active-directory',
  templateUrl: './active-directory.component.html'
})
export class ActiveDirectoryComponent implements OnInit {

  ApiUrl = "/api/admin/ADConnection/";
  searchTextBox: TextBoxOptions;
  ShowPageContent = false;
  PermissionSetList: any[] = [];
  LanguagesList: any[] = [];
  WelcomeMsgTempList: any[] = [];
  mappingTypesList: any[] = [];
  mappingPropertiesList: any[] = [];

  ActiveDirectoryForm = new FormGroup({});
  showFilter: boolean = false;
  ActiveDirectoryPagingResult: any[] = [];
  ActiveDirectoryPaging: PagingOptions;
  TextInputFilter: FilterItem;
  IsFilterLoaded: boolean = false;
  ProductionMode: boolean = false;
  @ViewChild('ActiveDirectoryPagingViewElement', { static: false }) input: ElementRef;

  ////Edit Model Controls
  EditActiveDirectoryForm = new FormGroup({});
  EditName: TextBoxOptions;
  EditDomain: TextBoxOptions;
  EditSamAccount: TextBoxOptions;
  EditIdentifier: string;
  EditTypeName: string;
  EditPassword: TextBoxOptions;
  EditInactive: ToggleSlideOptions;
  EditDailyJob: ToggleSlideOptions;
  EditPermissionSetOptions: DropdownOptions;
  EditLanguageOptions: DropdownOptions;
  EditWelcomeMsgTemplateOptions: DropdownOptions;
  EditMappingsOptions: any[] = [];
  EditMappingsCount: number;
  //EditProviderTypeItemID: number = 0;
  //EditProviderAttributesOptions: any[] = [];
  //EditProviderAttributesCount: number = 0;


  IsEditActiveDirectoryModalLoaded: boolean;
  ActiveDirectoryId: number;
  @ViewChild('CloseEditActiveDirectoryModal', { static: false }) CloseEditActiveDirectoryModal: ElementRef;

  ////delete  Model Controls
  //deleteProviderList: any[] = []
  //IsOpenDeleteProviderModal: boolean = false
  //@ViewChild('CloseDeleteProviderModal', { static: false }) CloseDeleteProviderModal: ElementRef;

  //delete  Model Controls
  deleteActiveDirectoryId: string;
  IsOpenDeleteActiveDirectoryModal: boolean = false
  @ViewChild('CloseDeleteActiveDirectoryModal', { static: false }) CloseDeleteActiveDirectoryModal: ElementRef;

  //Last run logs
  lastRunLogsForm = new FormGroup({});
  ADConnectionName: string;
  LastRunLogs: string;
  IslastRunLogsModalLoaded: boolean = false;
  @ViewChild('CloseLAstRunLogsActiveDirectoryModal', { static: false }) CloseLAstRunLogsActiveDirectoryModal: ElementRef;


  //Synchronization modal
  syncActiveDirectoryId: string;
  IsOpenSyncActiveDirectoryModal: boolean = false
  @ViewChild('CloseSyncActiveDirectoryModal', { static: false }) CloseSyncActiveDirectoryModal: ElementRef;

  language: string = ""

  constructor(private authService: AuthService, private pageInfoService: PageInfoService, public utilityService: UtilityService, private bbsfTranslateService: BBSFTranslateService, private environmentService: EnvironmentService, private ActiveDirectoryService: ActiveDirectoryService) {
  }
  async ngOnInit(): Promise<void> {
    this.ShowPageContent = true;
    PageInfoService.PageTitle = this.utilityService.getResourceValue("ActiveDirectories")
    PageInfoService.PageBreadcrumbs = [
      { title: this.utilityService.getResourceValue("Home"), path: '/Admin/Home', isSeparator: false, isActive: false },
      { title: '', path: '', isSeparator: true, isActive: false }

    ];
    this.pageInfoService.calculateTitle();
    this.pageInfoService.calculateBreadcrumbs();
    this.bbsfTranslateService.onLangChange.subscribe((event) => {
      this.ShowPageContent = false;
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language = await this.utilityService.getCurrentLanguage();
    this.ProductionMode = this.environmentService.getProductionMode()
    this.initializePage();
  }


  resetFilters() {
    this.ActiveDirectoryForm.controls["searchTextBox"].setValue(null);
    let element = this.input as any;
    element.ReinitializePaging();
  }
  //initialize filters and load any drop down list
  initializePage() {
    // TextBox inti
    this.searchTextBox = new TextBoxOptions();
    this.searchTextBox.Name = "searchTextBox"
    this.searchTextBox.Type = InputType.Text
    this.searchTextBox.Placeholder = this.utilityService.getResourceValue("SearchByName")
    this.searchTextBox.HideLabel = true

    this.TextInputFilter = new FilterItem();
    this.TextInputFilter.FormControlName = "searchTextBox"
    this.TextInputFilter.ActionParameterName = "searchText"
    this.TextInputFilter.IsFormControl = true
    this.TextInputFilter.FilterType = FilterType.TextBox

    // Provider Types Filter Init   

    this.ActiveDirectoryPaging = new PagingOptions();
    debugger;
    this.ActiveDirectoryPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetADConnectionByFilter';
    this.ActiveDirectoryPaging.OnKeyPressFiltersControlNames = ["searchTextBox"];
    this.ActiveDirectoryPaging.Filters = [this.TextInputFilter]
    this.ActiveDirectoryPaging.ValidationToken = this.authService.authorizationHeaderValue();

    setTimeout(() => {
      this.IsFilterLoaded = true;
    }, 10);
  }

  ReinitializeActiveDirectoryPaging() {
    let element = this.input as any;
    element.ReinitializePaging();
  }

  UpdateActiveDirectoryPaging() {
    let element = this.input as any;
    element.UpdatePaging();
  }

  setActiveDirectoryListResult(result) {
    this.ActiveDirectoryPagingResult = result;
    this.ShowPageContent = true;
    this.utilityService.stopBlockUI()
  }


  editActiveDirectory() {
    if (this.EditActiveDirectoryForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.EditActiveDirectoryForm.value;
      let EditModel = new ActiveDirectoryAddEditModel();

      EditModel.ID = Number(this.ActiveDirectoryId);
      EditModel.ConnectionName = ResultModel.EditName; //(##1)
      EditModel.Domain = ResultModel.EditDomain;
      EditModel.SamAccount = ResultModel.EditSamAccount;
      EditModel.Password = ResultModel.EditPassword;
      EditModel.PermissionSetID = ResultModel.EditPermissionSetOptions != null ? Number(ResultModel.EditPermissionSetOptions) : null
      EditModel.LangKey = ResultModel.EditLanguageOptions;
      EditModel.WelcomeTemplateID = ResultModel.EditWelcomeMsgTemplateOptions != null ? Number(ResultModel.EditWelcomeMsgTemplateOptions) : null
      EditModel.MarkAsInactive = ResultModel.EditInactive;
      EditModel.AddToDailyJob = ResultModel.EditDailyJob;

      for (let j = 0; j < this.EditMappingsCount; j++) {
        let editMAppingType = ResultModel["ADMappingType" + j];
        if (editMAppingType == undefined)
          continue;
        let editMAppingProperty = ResultModel["ADMappingProperty" + j];
        let editMAppingPropertyName = ResultModel["ADMappingPropertyName" + j];

        let adMAppingObj: ADMappingModel = new ADMappingModel();
        adMAppingObj.ADMappingTypeItemID = Number(editMAppingType);
        adMAppingObj.BBSFPropertyName = editMAppingProperty;
        adMAppingObj.ADPropertyName = editMAppingPropertyName;
        EditModel.ADMappings.push(adMAppingObj);
      }

      this.ActiveDirectoryService.EditActiveDirectory(EditModel).subscribe((result) => {
        debugger;
        document.getElementById('CloseEditActiveDirectoryModal').click()
        this.EditActiveDirectoryForm.reset()
        let element = this.input as any;
        element.UpdatePaging();
      }, (error) => {
      })
    }
  }

  showEditActiveDirectoryModal(ActiveDirectoryID: number, ActiveDirectoryIDEnc: string) {
    this.ActiveDirectoryService.GetEditActiveDirectory(ActiveDirectoryIDEnc).subscribe((result) => {
      let dataResult = result as any;
      //get active directory data
      let activeDirectory = dataResult.model
      //Load ists
      this.PermissionSetList = dataResult.dropdownsData.permissionSets;
      this.LanguagesList = dataResult.dropdownsData.languages;
      this.WelcomeMsgTempList = dataResult.dropdownsData.templates;
      this.mappingTypesList = dataResult.dropdownsData.mappingTypes;
      this.mappingPropertiesList = dataResult.dropdownsData.mappingProperties;


      this.IsEditActiveDirectoryModalLoaded = false;
      this.utilityService.startBlockUI();
      this.EditActiveDirectoryForm.reset();
      this.ActiveDirectoryId = ActiveDirectoryID;


      this.EditName = new TextBoxOptions();
      this.EditName.Name = "EditName";   /*used when call the control (important) (##1)*/
      this.EditName.LabelKey = "Name";
      this.EditName.Type = InputType.Text;
      this.EditName.IsRequired = true;
      this.EditName.Value = activeDirectory.connectionName;

      let selectedPermissionSet = this.PermissionSetList.filter((item) => { return item.key == activeDirectory.permissionSetID; }).map((item) => item.key)[0];

      this.EditPermissionSetOptions = new DropdownOptions();
      this.EditPermissionSetOptions.Name = "EditPermissionSetOptions"
      this.EditPermissionSetOptions.LabelKey = "PermissionSet"
      this.EditPermissionSetOptions.DataSource = this.PermissionSetList
      this.EditPermissionSetOptions.SingleSelection = true;
      this.EditPermissionSetOptions.AllowSearchFilter = true;
      this.EditPermissionSetOptions.Placeholder = "";
      this.EditPermissionSetOptions.IsRequired = true;
      this.EditPermissionSetOptions.SelectedItems = selectedPermissionSet;

      let selectedLanguage = this.LanguagesList.filter((item) => { return item.key == activeDirectory.langKey; }).map((item) => item.key)[0];

      this.EditLanguageOptions = new DropdownOptions();
      this.EditLanguageOptions.Name = "EditLanguageOptions"
      this.EditLanguageOptions.LabelValue = "Language"
      this.EditLanguageOptions.LabelKey = "Language"
      this.EditLanguageOptions.DataSource = this.LanguagesList
      this.EditLanguageOptions.SingleSelection = true;
      this.EditLanguageOptions.AllowSearchFilter = true;
      this.EditLanguageOptions.Placeholder = "";
      this.EditLanguageOptions.IsRequired = true;
      this.EditLanguageOptions.SelectedItems = selectedLanguage;

      let selectedWelcomeMsgTemp = activeDirectory.welcomeTemplateID != null ? this.WelcomeMsgTempList.filter((item) => { return item.key == activeDirectory.welcomeTemplateID; }).map((item) => item.key)[0] : null;

      this.EditWelcomeMsgTemplateOptions = new DropdownOptions();
      this.EditWelcomeMsgTemplateOptions.Name = "EditWelcomeMsgTemplateOptions"
      this.EditWelcomeMsgTemplateOptions.LabelKey = "WelcomeMsgTemplate"
      this.EditWelcomeMsgTemplateOptions.DataSource = this.WelcomeMsgTempList
      this.EditWelcomeMsgTemplateOptions.SingleSelection = true;
      this.EditWelcomeMsgTemplateOptions.AllowSearchFilter = true;
      this.EditWelcomeMsgTemplateOptions.Placeholder = "";
      this.EditWelcomeMsgTemplateOptions.IsRequired = false;
      this.EditWelcomeMsgTemplateOptions.SelectedItems = selectedWelcomeMsgTemp;

      this.EditIdentifier = activeDirectory.identifier;
      this.EditTypeName = activeDirectory.adConnectionTypeItemName;

      this.EditDomain = new TextBoxOptions();
      this.EditDomain.Name = "EditDomain";   /*used when call the control (important) (##1)*/
      this.EditDomain.LabelKey = "Domain";
      this.EditDomain.Type = InputType.Text;
      this.EditDomain.IsRequired = true;
      this.EditDomain.Value = activeDirectory.domain;

      this.EditSamAccount = new TextBoxOptions();
      this.EditSamAccount.Name = "EditSamAccount";   /*used when call the control (important) (##1)*/
      this.EditSamAccount.LabelKey = "SamAccount";
      this.EditSamAccount.Type = InputType.Text;
      this.EditSamAccount.Value = activeDirectory.samAccount;

      this.EditPassword = new TextBoxOptions();
      this.EditPassword.Name = "EditPassword";   /*used when call the control (important) (##1)*/
      this.EditPassword.LabelKey = "Password";
      this.EditPassword.Type = InputType.Password;
      this.EditPassword.RemoveDefaultPasswordValidation = true;
      this.EditPassword.Value = activeDirectory.password;

      this.EditInactive = new ToggleSlideOptions();
      this.EditInactive.Name = "EditInactive";
      this.EditInactive.Value = activeDirectory.markAsInactive;
      this.EditInactive.LabelKey = "MarkAsInactive"
      this.EditInactive.ViewType = ControlLayout.Horizontal;


      this.EditDailyJob = new ToggleSlideOptions();
      this.EditDailyJob.Name = "EditDailyJob"
      this.EditDailyJob.LabelKey = "AddToDailyJob"
      this.EditDailyJob.Value = activeDirectory.addToDailyJob;
      this.EditDailyJob.ViewType = ControlLayout.Horizontal;

      let data: any = this.getADMappingOptions(activeDirectory.adMappings);

      this.EditMappingsOptions = data[0];
      this.EditMappingsCount = data[1];

      setTimeout(() => {
        this.IsEditActiveDirectoryModalLoaded = true;
      }, 100);
    }, (error) => {

    })
  }
  getADMappingOptions(ADMappings: any[]) {
    let ADMappingOptions: any[] = [];
    let ADMappingCount: number = 0;
    for (let i = 0; i < ADMappings.length; i++) {

      let objectMappingOptions: any[] = [];

      let ADMappingType = new DropdownOptions();
      let selectedType = this.mappingTypesList.filter((item) => { return item.key == ADMappings[i].adMappingTypeItemID; }).map((item) => item.key)[0];
      ADMappingType.Name = "ADMappingType" + i;
      ADMappingType.HideLabel = true;
      ADMappingType.SingleSelection = true;
      ADMappingType.SelectedItems = selectedType;
      ADMappingType.ViewType = ControlLayout.Horizontal;
      ADMappingType.DataSource = this.mappingTypesList;

      let ADMappingProperty = new DropdownOptions();
      let selectedProperty = this.mappingPropertiesList.filter((item) => { return item.key == ADMappings[i].bbsfPropertyName; }).map((item) => item.key)[0];
      ADMappingProperty.Name = "ADMappingProperty" + i;
      ADMappingProperty.HideLabel = true;
      ADMappingProperty.SingleSelection = true;
      ADMappingProperty.SelectedItems = selectedProperty;
      ADMappingProperty.ViewType = ControlLayout.Horizontal;
      ADMappingProperty.DataSource = this.mappingPropertiesList;


      let ADMappingPropertyName = new TextBoxOptions();
      ADMappingPropertyName.Name = "ADMappingPropertyName" + i;
      ADMappingPropertyName.HideLabel = true;
      ADMappingPropertyName.Type = InputType.Text;
      ADMappingPropertyName.Value = ADMappings[i].adPropertyName;
      ADMappingPropertyName.IsRequired = false;
      ADMappingPropertyName.ViewType = ControlLayout.Horizontal;

      let ADMappingIncludeUpdate = new CheckBoxOptions();
      ADMappingIncludeUpdate.Name = "ADMappingIncludeUpdate" + i;
      ADMappingIncludeUpdate.Value = ADMappings[i].includeInUpdate;
      ADMappingIncludeUpdate.IsDisabled = true;


      objectMappingOptions.push(ADMappingType, ADMappingProperty, ADMappingPropertyName, ADMappingIncludeUpdate);
      ADMappingOptions.push(objectMappingOptions);
      ADMappingCount += 1;

    }
    return [ADMappingOptions, ADMappingCount];
  }
  showDeleteActiveDirectoryModal(activeDirectory: any) {
    this.deleteActiveDirectoryId = activeDirectory.idEncrypted;
    this.IsOpenDeleteActiveDirectoryModal = false;
    this.utilityService.startBlockUI();
    setTimeout(() => {
      this.IsOpenDeleteActiveDirectoryModal = true;
      this.utilityService.stopBlockUI();
    }, 100);
  }

  deleteActiveDirectory() {
    this.ActiveDirectoryService.DeleteActiveDirectory(this.deleteActiveDirectoryId).subscribe((result) => {
      this.deleteActiveDirectoryId = "";
      document.getElementById('CloseDeleteActiveDirectoryModal').click()
      let element = this.input as any;
      element.ReinitializePaging();
    }, (error) => {
    })
  }
  showADSynchronizationModal(ActiveDirectoryID: string) {
    this.syncActiveDirectoryId = ActiveDirectoryID;
    this.IsOpenSyncActiveDirectoryModal = false;
    this.utilityService.startBlockUI();
    setTimeout(() => {
      this.IsOpenSyncActiveDirectoryModal = true;
      this.utilityService.stopBlockUI();
    }, 100);
  }
  runSyncronization() {
    this.ActiveDirectoryService.RunADSynchronization(this.syncActiveDirectoryId).subscribe((result) => {
      this.syncActiveDirectoryId = "";
      document.getElementById('CloseSyncActiveDirectoryModal').click()
      let element = this.input as any;
      element.ReinitializePaging();
    }, (error) => {

    })
  }
  showADLastRunLogsModal(ActiveDirectoryID: string) {
    this.ActiveDirectoryService.GetLastRunLogs(ActiveDirectoryID).subscribe((result) => {
      let lastRunLogsModel = result as any;

      this.IslastRunLogsModalLoaded = false;
      this.ADConnectionName = lastRunLogsModel.model.adConnectionName;
      this.LastRunLogs = lastRunLogsModel.model.logs;


      setTimeout(() => {
        this.IslastRunLogsModalLoaded = true;
      }, 100);
    }, (error) => {
    })
  }

  deleteADMapping(deletedADMApping: any) {
    debugger;
    let deletedMappingIndex: number = this.EditMappingsOptions.indexOf(deletedADMApping);
    if (deletedMappingIndex !== -1) {
      this.EditMappingsOptions.splice(deletedMappingIndex, 1);
      for (var i = 0; i < deletedADMApping.length; i++) {
        this.EditActiveDirectoryForm.removeControl(deletedADMApping[i].Name);
      }
    }
  }

}
